import { render } from "./FPluginTreerq.vue?vue&type=template&id=ec2adf90&scoped=true"
import script from "./FPluginTreerq.vue?vue&type=script&lang=js"
export * from "./FPluginTreerq.vue?vue&type=script&lang=js"

import "./FPluginTreerq.vue?vue&type=style&index=0&id=ec2adf90&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec2adf90"]])

export default __exports__